<template>
  <div class="redemption-records" v-if="orderList">
    <Header />
    <div class="records-main">
      <div class="title">Redemption records</div>
      <div class="list-title">
        <div>Date</div>
        <div>Prize Name</div>
        <div>Status</div>
      </div>
      <div class="list">
        <div class="list-item" v-for="(item, index) in orderList" :key="index">
          <div>{{ item.confirmDate }}</div>
          <div>{{ item.giftName }}</div>
          <div>{{ item.status }}</div>
        </div>
      </div>
      <div class="paging-fa">
        <div class="paging">
          <span class="left" @click="reducePage"><</span>
          <input
            type="text"
            name=""
            v-model="currentPage"
            oninput="value=value.replace(/[^\d]/g,'')"
            @blur="onblur"
            @focus="onfocus"
          />
          <span class="line"> / </span>
          <span class="total">{{ totalPage }}</span>
          <span class="right" @click="nextPages">></span>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./mycom/header.vue";
import Footer from "./mycom/footer.vue";
import { Orders } from "@/api/api.js";
import { Notify } from "vant";
export default {
  components: { Header, Footer },
  data() {
    return {
      currentPage: 1,
      oldPage: null,
      pageSize: 10,
      totalPage: null,
      orderList: null,
    };
  },
  methods: {
    getOrderList() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
        page: this.currentPage,
        size: this.pageSize,
      };
      Orders(params).then((res) => {
        if (res.code === 200) {
          console.log(res);
          this.orderList = res.data.list;
          this.totalPage = res.data.pagebar.totalPage;
        } else {
          Notify({ type: "warning", message: res.errors });
        }
      });
    },
    reducePage() {
      let currentPage = this.currentPage - 1;
      if (currentPage < 1) {
        return;
      }
      this.currentPage = currentPage;
      this.getOrderList();
    },
    nextPages() {
      console.log(333);
      let currentPage = parseInt(this.currentPage) + 1;
      console.log('currentPage',currentPage)
      if (currentPage > this.totalPage) {
        return;
      }
      this.currentPage = currentPage;
      this.getOrderList();
    },
    onfocus() {
      console.log(123);
      this.oldPage = this.currentPage;
    },
    onblur() {
      if (this.currentPage < 1 || this.currentPage > this.totalPage) {
        this.currentPage = this.oldPage;
        return;
      }
      this.getOrderList()
    },
  },
  created() {
    this.getOrderList();
  },
};
</script>
<style scoped>
.redemption-records {
  padding-top: 40px;
  min-height: calc(100vh - 40px);
  background-color: #fff;
}
header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.records-main {
  width: calc(100% - 175px);
  padding: 20px 87.5px;
}
.records-main .title {
  font-size: 10px;
  font-weight: bold;
  color: #232323;
}
.list-title {
  display: flex;
  justify-content: space-between;
}
.list-title > div {
  width: 100px;
  font-size: 10px;
  margin-top: 10px;
}
.list{
  min-height: 300px;
}
.list-item {
  display: flex;
  justify-content: space-between;
}
.list-item > div {
  width: 100px;
  font-size: 10px;
  margin-top: 20px;
}
.paging-fa {
  display: flex;
  width: 100%;
  justify-content: center;
}
.paging {
  margin-top: 40px;
  display: flex;
  align-items: center;
}
.paging > input {
  width: 22.5px;
  height: 20px;
  background: #ffffff;
  border-radius: 1.25px;
  border: 0.625px solid #dcdee0;
  padding-left: 12.5px;
}
.paging > .left {
  margin-right: 15px;
  cursor: pointer;
}
.line {
  margin-left: 15px;
}
.total {
  margin-left: 15px;
}
.paging > .right {
  margin-left: 15px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/redemptionRecords.vue